import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-5b4dcdf0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tree-box"
};
const _hoisted_2 = {
  class: "dialog-footer"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定");

import { computed } from 'vue';
export default {
  props: {
    show: Boolean,
    // 操作类型 0 分配 1 选择
    type: {
      type: Number,
      default: 0
    },
    courseId: String,
    // 选中的
    selected: String
  },
  emits: ['update:show', 'handleSeletedChapter'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const dialogTitle = computed(() => {
      if (props.type === 0) {
        return '分配至';
      } else if (props.type === 1) {
        return '选择章节';
      }
    });
    const $http = inject('$http');
    const chapterTree = ref();
    const treeProps = {
      value: 'id',
      label: 'name',
      children: 'children'
    };
    const chapterList = ref([]);

    const handleClose = () => {
      emit('update:show', false);
    }; // 保存


    const handleConfirm = () => {
      const selected = chapterTree.value.getCurrentNode();

      if (!selected || selected.id == 0) {
        ElMessage.warning('当前未选择任何章节');
        return;
      }

      console.log('selected', selected);
      emit('handleSeletedChapter', selected);
      handleClose();
    }; // 获取章节树


    const getChapterList = async course_id => {
      const chapter = await $http.getCourseChapterTree({
        course_id
      });

      if (chapter && chapter.length) {
        chapterList.value = [{
          id: 0,
          name: '全部',
          children: chapter || []
        }];
      }
    };

    watch(() => props.courseId, value => {
      value && getChapterList(value);
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: __props.show,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(show) ? show.value = $event : null),
        width: "520px",
        title: _unref(dialogTitle),
        "before-close": handleClose,
        "destroy-on-close": "",
        "close-on-click-modal": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          size: "large",
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[0] || (_cache[0] = $event => handleConfirm())
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tree, {
          ref_key: "chapterTree",
          ref: chapterTree,
          "node-key": "id",
          data: chapterList.value,
          "current-node-key": __props.selected,
          "highlight-current": true,
          "default-expand-all": true,
          "expand-on-click-node": false,
          props: treeProps,
          "empty-text": "暂无章节"
        }, null, 8, ["data", "current-node-key"])])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }

};